import { memo, useEffect, useMemo, useRef } from 'react';
import feather from 'feather-icons';

export interface IconProps {
	name: string;
	size?: number | string;
	className?: string;
	strokeWidth?: number;
	color?: string;
}

/**
 * Icon component wrapper for Feather Icons
 * Renders Feather Icons as inline SVG
 */
const Icon = ({
	name,
	size = 24,
	className = '',
	strokeWidth = 2,
	color,
}: IconProps) => {
	const iconRef = useRef<HTMLDivElement>(null);

	const iconClass = useMemo(() => `feather-icon ${className}`, [className]);
	const iconStyle = useMemo(
		() => ({ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }),
		[]
	);

	useEffect(() => {
		if (!iconRef.current) return;

		if (!feather.icons[name]) {
			console.warn(`Feather icon "${name}" not found`);
			iconRef.current.innerHTML = '';
			return;
		}

		const icon = feather.icons[name];
		const svg = icon.toSvg({
			width: size,
			height: size,
			'stroke-width': strokeWidth,
			...(color && { color }),
		});
		iconRef.current.innerHTML = svg;
	}, [name, size, strokeWidth, color]);

	return (
		<span
			ref={iconRef}
			className={iconClass}
			aria-hidden="true"
			style={iconStyle}
		/>
	);
};

export default memo(Icon);
